import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import GradeBadge from '../../../../common/components/GradeBadge/GradeBadge';

export const IssuedDateTypography = styled(Typography)`
    margin-top: 16px;
    margin-bottom: 0px;
    text-align: center;
`;

export const LeftButtonContainer = styled.div`
    text-align: left;
    flex: 1;
`;

export const RightButtonContainer = styled.div`
    text-align: right;
    flex: 1;
`;

export const StyledCard = styled(Card)`
    margin: 8px;
    min-width: 300px;
    min-height: 200px;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const StyledGradeBadge = styled(GradeBadge)`
    margin: 0 auto;
    width: 128px;
    height: 128px;
    font-size: 4.5rem;
`;

export const StyledIconButton = styled(IconButton)`
    margin: 0 4px;
`;
